import React, { useContext, useEffect, useState } from "react";
import { Segment, Grid, Dropdown, Button, Label } from "semantic-ui-react";
import { observer } from "mobx-react-lite";

import BreadcrumbContainer from "../../../app/common/breadcrumb/BreadcrumbContainer";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadingComponent from "../../../app/layout/LoadingComponent";

import IdDocumentConfiguration from "./IdDocumentConfiguration";
import { documentsType } from "./constants";
import SendDocumentToProd from "./SendDocumentToProd";
import ResetSetTestDocumentIdModal from "./ResetSetTestDocumentIdModal";

interface IProps {
  sections: any[];
}
const DashboardDianV2: React.FC<IProps> = ({ sections }) => {
  document.title = "Set de pruebas";
  const rootStore = useContext(RootStoreContext);
  const { getTestSetDocuments, loadTestSetDocument, testSetDocuments } = rootStore.companyStore;
  const { openModal } = rootStore.modalStore;

  const [activeDocument, setActiveDocument] = useState<string>('InvoiceSale');
  const documentsState = JSON.parse(JSON.stringify(testSetDocuments));
  const activeDocumentState = documentsState?.[`${activeDocument}`];

  const hasErrorTestSetDocument = activeDocumentState?.status === 3;
  const isActiveDocumentProdEnabled = activeDocumentState?.status !== 0 && !hasErrorTestSetDocument;
  const isRestoreButtonDisabled = !activeDocumentState?.id;

  const errorLabel = activeDocumentState?.details || "Error al cargar el set de pruebas";

  useEffect(() => {
    getTestSetDocuments();
  }, [getTestSetDocuments]);

  if (!loadTestSetDocument) {
    return <LoadingComponent content="Cargando Set de pruebas" />;
  }


  const selectDocumentOptions = [
    {
      key: 'InvoiceSale',
      text: 'Factura electrónica',
      value: documentsType.invoiceSale,
    },
    {
      key: 'SupportDocument',
      text: 'Documento soporte',
      value: documentsType.supportDocument,
    },
    {
      key: 'EquivalentDocumentSPD',
      text: 'Documento equivalente',
      value: documentsType.equivalentDocumentSPD,
    },
  ];

  const handleDocumentSelection = (e: any, data: any) => {
    setActiveDocument(data.value);
  };

  const handleResetSetTestDocument = () => {
    openModal(
      <ResetSetTestDocumentIdModal activeDocumentState={activeDocumentState} activeDocument={activeDocument} />,
      "Restablecer identificador",
    )
  };

  return (
    <div className="configurationContent">
      <BreadcrumbContainer title="Conjunto de pruebas Dian" sections={sections} />
      <Segment padded="very">
        <Grid columns={2} stackable>
          <Grid.Row>
            <span className="dropdown-label">
              Set de pruebas para:
              <Dropdown
                defaultValue={activeDocument}
                selection
                options={selectDocumentOptions}
                onChange={handleDocumentSelection}
              />
            </span>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Segment padded="very" className="stepsp">
                <Label className="steps" color="green" floating size="big">
                  1
                </Label>
                <IdDocumentConfiguration activeDocumentState={activeDocumentState} activeDocument={activeDocument} />
              </Segment>
            </Grid.Column>
            <Grid.Column>
              <Segment padded="very" className={`stepsp ${!isActiveDocumentProdEnabled ? "disabled" : ""}`}>
                <Label
                  className="steps"
                  floating size="big"
                  children="2"
                  {...(isActiveDocumentProdEnabled ? { color: "green" } : {})}
                />
                <SendDocumentToProd
                  activeDocumentState={activeDocumentState}
                  isDisabled={!isActiveDocumentProdEnabled}
                  activeDocument={activeDocument}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            { hasErrorTestSetDocument && (
              <Label
                className="set-test-error-label"
                basic
                color="red"
              >
                { errorLabel }
              </Label>
              )
            }
            <Button
              className="ui primary button"
              icon="delete"
              color="blue"
              content="Restablecer set de pruebas"
              type="button"
              disabled={isRestoreButtonDisabled}
              onClick={handleResetSetTestDocument}
            />
          </Grid.Row>
        </Grid>
      </Segment>
    </div>
  );
};

export default observer(DashboardDianV2);
